import './orchestrators/addCalendarEventsOrchestrator';
import ActionMessageId from './schema/ActionMessageId';
import ActionType from './schema/ActionType';
import AttachmentFullViewState from './schema/AttachmentFullViewState';
import AttachmentFullViewStrategy from './schema/AttachmentFullViewStrategy';
import AttachmentMenuAction from './schema/AttachmentMenuAction';
import AttachmentState from './schema/AttachmentState';
import AttachmentStateType from './schema/AttachmentStateType';
import InlineAttachmentState from './schema/InlineAttachmentState';
import InlineAttachmentStatus from './schema/InlineAttachmentStatus';
import { ImageLoadState } from 'owa-attachment-data';

// Exporting actions
export {
    default as createAttachmentFullViewStateAndStoreBackingModel,
} from './actions/createAttachmentFullViewStateAndStoreBackingModel';
export { default as cancelConvertClassicToCloudy } from './actions/cancelConvertClassicToCloudy';
export { default as convertClassicToCloudy } from './actions/convertClassicToCloudy';
export {
    default as saveToCloud,
    saveToCloudPreProcess,
    saveToCloudPostProcess,
} from './actions/saveToCloud';
export { default as addCalendarEventsAttachment } from './actions/addCalendarEventsAttachment';
export { default as setActionCompletePercent } from './actions/setActionCompletePercent';
export {
    default as setAttachmentShouldShowContextMenu,
} from './actions/setAttachmentShouldShowContextMenu';
export { default as setInlineAttachmentStatus } from './actions/setInlineAttachmentStatus';
export {
    default as setOngoingActionAndActionMessage,
} from './actions/setOngoingActionAndActionMessage';
export { default as setShouldShowImageOverlay } from './actions/setShouldShowImageOverlay';
export { default as updateAttachment } from './actions/updateAttachment';
export {
    default as initializeAttachmentFullViewState,
    getDefaultSupportedMenuAction,
} from './actions/initialization/initializeAttachmentFullViewState';
export {
    default as cancelConvertCloudyToClassic,
} from './orchestrators/cancelConvertCloudyToClassic';
export { default as convertCloudyToClassic } from './orchestrators/convertCloudyToClassic';
export { ConvertCloudyToClassicSource } from './schema/ConvertCloudyToClassicSource';
export { getAttachmentSharingInformation } from './utils/getAttachmentSharingInformation';

// Exporting utils
export {
    default as startFakeProgressIndicator,
    stopFakeProgressIndicator,
} from './utils/FakeProgressIndicator';
export {
    default as actionCompleteTimeEstimators,
    getAttachCloudFileCompleteTimeInMS,
    getAttachUriFileCompleteTimeInMS,
    getShareLocalFileCompleteTimeInMS,
    getAddToCalendarEventEstimateCompleteTimeInMS,
} from './utils/actionCompleteTimeEstimators';
export { default as createAttachmentFullViewState } from './utils/createAttachmentFullViewState';
export { default as createInlineAttachmentState } from './utils/createInlineAttachmentState';
export {
    default as getSaveToCloudEstimatedCompleteTimeInMS,
} from './utils/actionCompleteTimeEstimators';
export { default as isSaveToCloudApplicable } from './utils/isSaveToCloudApplicable';
export { default as isInlineAttachmentStateType } from './utils/isInlineAttachmentStateType';

// Exporting types
export {
    ActionMessageId,
    ActionType,
    AttachmentFullViewState,
    AttachmentFullViewStrategy,
    AttachmentMenuAction,
    AttachmentState,
    AttachmentStateType,
    InlineAttachmentState,
    InlineAttachmentStatus,
    ImageLoadState,
};
